import { useState, useEffect } from 'react'
import Pagination from 'react-bootstrap/Pagination';
import { getCallingoActivityLog } from './../../utils/APIClient'
import moment from 'moment'
export default function Activities() {
    document.title = "Callingo | Activities"
    const [ActivityLog, setActivityLog] = useState([])
    const [totalPages, settotalPages] = useState()
    const [page_size, setpage_size] = useState(10)
    const [page_number, setpage_number] = useState(1)
    const [loading, setLoading] = useState(false);
    let active = 1;
    let items = [];
    for (let number = 1; number <= totalPages; number++) {
        items.push(
            <Pagination.Item key={number} active={number === active}>
            {number}
            </Pagination.Item>,
        );
    }
    const getCallingoActivity = async (pagesize, pagenumber) => {
        setpage_size(pagesize)
        setLoading(true);
        try {
            let ActivityLog = await getCallingoActivityLog(pagesize, pagenumber);
            if (ActivityLog.data) {
                setLoading(false);
                setActivityLog([...ActivityLog.data.results.data])
                settotalPages(ActivityLog.data.results.pagination.total_items)

            }
        } catch (error) {
            setLoading(false);
            console.error(error);
        }
    }
    useEffect(() => {
        getCallingoActivity(page_size, page_number)
    }, [])
    return (
        <>
            <div className="row">
                <div className="col-12">
                    <div className="page-title-box">
                        <h4 className="page-title lh-1 mb-3">Activity Feed </h4>
                    </div>
                </div>
                <div className="col-xl-12">
                    <div className="card">
                        <div className="card-header d-flex justify-content-between align-items-center">
                            <h4 className="header-title   ">Recent actions and changes you've made</h4>
                        </div>
                        <div className="card-body py-0 mb-3" data-simplebar style={{ maxheight: '700px' }}>
                            {loading ? <div className="text-center">   <div className="spinner-border text-success m-2" role="status"></div></div> : 
                            <div className="timeline-alt py-0">
                                {ActivityLog.map((items, i) => {
                                    return (
                                        <div className="timeline-item" key={"activity" + i}>
                                            <i className="  text-bg-success timeline-icon"></i>
                                            <div className="timeline-item-info">
                                                <p className="text-info mb-0 d-block">{items.description}</p>
                                                <p className="mb-0 pb-2">
                                                    <small className="text-muted">{moment(items.action_date).fromNow()}</small>
                                                </p>
                                            </div>
                                        </div>
                                    )
                                })}

                                {ActivityLog.length === 0 && (  <div> There are no records to display </div> )}
                                <button className="btn btn-success  mt-0 page-title-right" onClick={()=> {getCallingoActivity(page_size + 10, page_number) }} >Load More Activities</button>
                                
                            </div>}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
